"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.$testThirdPartyConfigurationByPayload = exports.$testThirdPartyConfigurationById = exports.$postThirdPartyConfiguration = exports.$patchThirdPartyConfiguration = exports.$getThirdPartyConfigurations = exports.$getOneThirdPartyConfiguration = exports.$deleteThirdPartyConfiguration = void 0;
var _oldHttpClient = require("../../apiClient/oldHttpClient");
var url = '/third-party';
var $getThirdPartyConfigurations = () => {
  return (0, _oldHttpClient.apiClient)({
    method: 'get',
    url,
    body: undefined
  });
};
exports.$getThirdPartyConfigurations = $getThirdPartyConfigurations;
var $getOneThirdPartyConfiguration = id => {
  return (0, _oldHttpClient.apiClient)({
    method: 'get',
    url: "".concat(url, "/").concat(id),
    body: undefined
  });
};
exports.$getOneThirdPartyConfiguration = $getOneThirdPartyConfiguration;
var $postThirdPartyConfiguration = body => {
  return (0, _oldHttpClient.apiClient)({
    method: 'post',
    url,
    body
  });
};
exports.$postThirdPartyConfiguration = $postThirdPartyConfiguration;
var $testThirdPartyConfigurationById = id => {
  return (0, _oldHttpClient.apiClient)({
    method: 'post',
    url: "".concat(url, "/test-connection"),
    body: {
      _thirdPartyConfiguration: id
    }
  });
};
exports.$testThirdPartyConfigurationById = $testThirdPartyConfigurationById;
var $testThirdPartyConfigurationByPayload = body => {
  return (0, _oldHttpClient.apiClient)({
    method: 'post',
    url: "".concat(url, "/test-connection"),
    body
  });
};
exports.$testThirdPartyConfigurationByPayload = $testThirdPartyConfigurationByPayload;
var $patchThirdPartyConfiguration = (id, body) => {
  return (0, _oldHttpClient.apiClient)({
    method: 'patch',
    url: "".concat(url, "/").concat(id),
    body
  });
};
exports.$patchThirdPartyConfiguration = $patchThirdPartyConfiguration;
var $deleteThirdPartyConfiguration = id => {
  return (0, _oldHttpClient.apiClient)({
    method: 'delete',
    url: "".concat(url, "/").concat(id),
    body: undefined
  });
};
exports.$deleteThirdPartyConfiguration = $deleteThirdPartyConfiguration;